import { render, staticRenderFns } from "./zyf.vue?vue&type=template&id=652e3e2e&scoped=true"
import script from "./zyf.vue?vue&type=script&lang=js"
export * from "./zyf.vue?vue&type=script&lang=js"
import style0 from "./zyf.vue?vue&type=style&index=0&id=652e3e2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652e3e2e",
  null
  
)

export default component.exports